import Col from "react-bootstrap/Col";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import { NavLink } from "react-router";
import { Logo } from "../../global";
import { Copyright } from "../../global/";
import NewsletterForm from "../../global/_newsletterform";
import "./index.scss";

const Footer = () => (
  <footer className="pdl_component_footer">
    <Container>
      <div className="d-md-none pdl_footer_mobile">
        <Row>
          <Logo variant="lex" />
        </Row>

        <Row className="mb-4">
          <Nav className="pdl_component_footer_nav mobile flex-column">
            <Nav.Link as={NavLink} to="/sobre">
              Sobre
            </Nav.Link>

            <Nav.Link as={NavLink} to="/ajuda">
              Ajuda
            </Nav.Link>
            <Nav.Link as={NavLink} to="/privacidade">
              Privacidade
            </Nav.Link>
            <Nav.Link as={NavLink} to="/sac">
              SAC
            </Nav.Link>
          </Nav>
        </Row>

        <Row className="footer-newsletter-mobile py-4">
          <Col xs={12} className="px-0">
            <NewsletterForm />
          </Col>
        </Row>

        <Row>
          <Col xs={12} className="text-center px-0">
            <Copyright />
          </Col>
        </Row>
      </div>

      {/* Desktop Layout */}
      <div className="d-none d-md-block pdl_footer_desktop">
        <Row className="mb-5 d-flex align-items-center py-2">
          <Col className="col-sm-auto ps-0">
            <Logo variant="lex" />
          </Col>
          <Col className="d-flex w-100 flex-row align-items-center justify-content-center pe-0">
            <Nav className="pdl_component_footer_nav">
              <Nav.Link as={NavLink} to="/sobre">
                Sobre
              </Nav.Link>
              <Nav.Link as={NavLink} to="/ajuda">
                Ajuda
              </Nav.Link>
              <Nav.Link as={NavLink} to="/privacidade">
                Privacidade
              </Nav.Link>

              <Nav.Link as={NavLink} to="/sac">
                SAC
              </Nav.Link>
            </Nav>
          </Col>
        </Row>
        <Row className="footer-newsletter-desktop py-4 d-flex align-items-center">
          <Col sm={6}>
            <NewsletterForm />
          </Col>
          <Col sm={6} className="text-end pe-0">
            <Copyright />
          </Col>
        </Row>
      </div>
    </Container>
  </footer>
);

export default Footer;
